import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InjectionToken, NgModule, Optional, SkipSelf } from '@angular/core';

import { httpInterceptorProviders } from './interceptors';

export interface ApiConfig {
  gatewayPath?: string;
  key: string;
  url: string;
  disableTimeout: boolean;
}

export const API_CONFIG = new InjectionToken<ApiConfig>('api.config');

@NgModule({
  exports: [],
  imports: [],
  providers: [httpInterceptorProviders, provideHttpClient(withInterceptorsFromDi())]
})
export class HttpModule {
  constructor(@Optional() @SkipSelf() parentModule: HttpModule) {
    if (parentModule) {
      throw new Error('HttpModule is already loaded. Import it in the AppModule only');
    }
  }
}
